import { YieldType } from "../../../globalTypes";
import { ASK_IDX, BID_IDX } from "../../constants";
import { EditedData, validateAndSetYieldValue } from "./validateAndSetYieldValue";

interface ValidateYieldValuesArgs {
  askValue: string;
  bidValue: string;
  relativeRow: number;
  editedSecurityData: EditedData;
  table: Excel.Table;
}

export const validateYieldValues = async ({
  askValue,
  bidValue,
  relativeRow,
  editedSecurityData,
  table,
}: ValidateYieldValuesArgs) => {
  const adjustedRow = relativeRow - 1;

  const invalidYieldValues = [
    !(await validateAndSetYieldValue({
      yieldType: YieldType.ASK,
      yieldValue: askValue,
      relativeRow: adjustedRow,
      editedSecurityData,
      table,
      relativeColumn: ASK_IDX,
    })),
    !(await validateAndSetYieldValue({
      yieldType: YieldType.BID,
      yieldValue: bidValue,
      relativeRow: adjustedRow,
      editedSecurityData,
      table,
      relativeColumn: BID_IDX,
    })),
  ];

  return invalidYieldValues.every((value) => value);
};
